var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { createHook, createStore } from "react-sweet-state";
import { LoadingStateDefaults } from "framework/state/loadingstate";
import { loadLast } from "framework/state/loader";
import { NoEntityError } from "framework/validation/validatableentity";
import { apiGetAthlete } from "./endpoint";
import { AthleteDefaults } from "./entity";
import { updateByCollectionResponse } from "framework/state/collection";
var StateDefaults = __assign(__assign({}, LoadingStateDefaults), { collection: [], entity: AthleteDefaults, errors: __assign({}, NoEntityError) });
var loadAthlete = function (idt) { return function (store) {
    var loader = function () { return apiGetAthlete(idt); };
    var stateProducer = function (store, _, response) {
        store.setState(function (draft) {
            updateByCollectionResponse(draft, response);
            if (draft.collection.length > 0) {
                if (draft.collection[0].idt === idt) {
                    draft.entity = draft.collection[0];
                }
            }
        });
    };
    loadLast(store, loader, stateProducer);
}; };
var store = createStore({
    initialState: StateDefaults,
    actions: {
        loadAthlete: loadAthlete,
    },
    name: "Athlete"
});
var useState = createHook(store);
export { StateDefaults as AthleteStateDefaults, useState as useAthlete, };
